<template>
	<div class="container">
		<div class="page p-1">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Notification Center') }}</h1>
					</div>
				</div>
			</div>

			<div class="page-body">
					<div class="card rounded-lg">
						<div class="card-body d-flex justify-content-start p-0 my-3 card-notification">
							<div class="tab-items w-100">
								<div class="tab-item-notification" :class="{'active' : activeTab === 'product'}" @click="switchTab('product')">Product
									<span>
										<span class="ml-1" v-if="unreadProductCount > 0">
											({{ unreadProductCount }})
										</span>
										<span class="unread-dot"  v-if="unreadProductCount > 0"></span>
									</span>
								</div>
								<div class="tab-item-notification d-flex align-center" :class="{'active' : activeTab === 'general'}" @click="switchTab('general')">General
									<span>
										<span class="ml-1" v-if="unreadGeneralCount > 0">
											({{ unreadGeneralCount }})
										</span>
										<span class="unread-dot"  v-if="unreadGeneralCount > 0"></span>
									</span>
								</div>
							</div>
						</div>
						<div class="card-body notification-section empty-state" v-if="notifications.length === 0 && !isFetching">
							<h4 class="text-center align-middle">Belum ada Notifikasi</h4>
						</div>
						<div class="card-body m-0 p-0 overflow-hidden" v-else>
							<list-text-loading :row-count="10"  v-if="isFetching && page === 1"/>
							<notification-center-item
								v-for="(notification, index) in notifications"
								:key="index"
								:item="notification"
							/>
							<list-text-loading  v-if="isFetching && page > 1"/>
						</div>
					</div>
				<!-- Card -->
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListTextLoading from '@/components/loading/ListTextLoading.vue';
import {
	formatDate,
} from '@/lib/helper';
import NotificationCenterItem from '@/components/NotificationCenterItem.vue';

export default {
	name: 'AdminNotificationCenter',
	components: {
		NotificationCenterItem,
		ListTextLoading,
	},
	data() {
		return {
			limit: 10,
			sortBy: 'created_at',
			sort: 'desc',
		};
	},
	methods: {
		...mapActions({
			getNotifications: 'notifications/getNotifications',
			setActiveTab: 'notifications/setActiveTab',
			setNotifications: 'notifications/setNotifications',
			decreaseUnreadProductNotification: 'notifications/decreaseUnreadProductNotification',
			decreaseUnreadGeneralNotification: 'notifications/decreaseUnreadGeneralNotification',
			setPage: 'notifications/setPage',
			setIsAll: 'notifications/setIsAll',
		}),
		formatDate,
		switchTab(type) {
			this.setPage(1);
			this.setActiveTab(type);
			this.fetchNotifications(true);
			this.setIsAll(false);
		},
		fetchNotifications(reset = false) {
			const params = {
				limit: this.limit,
				sort_by: this.sortBy,
				sort: this.sort,
				page: this.page,
			};

			if (this.activeTab === 'product') {
				params.type = 'product';
			} else {
				params.type = 'general';
			}

			const data = {
				params,
				reset,
			};

			this.getNotifications(data);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchNotifications(false);
				}
			}
		},
	},
	computed: {
		...mapGetters({
			isOwner: 'isOwner',
			activeTab: 'notifications/activeTab',
			unread: 'notifications/unread',
			unreadProductCount: 'notifications/unreadProductCount',
			unreadGeneralCount: 'notifications/unreadGeneralCount',
			notifications: 'notifications/notifications',
			isFetching: 'notifications/isFetching',
			page: 'notifications/page',
			isAll: 'notifications/isAll',
		}),
	},
	watch: {

	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
	},

	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>
	.tab-items {
		.tab-item-notification {
			display: block;
			position: relative;
			padding: 1em 1.5em;
			color: inherit;
			font-size: 14px;
			font-weight: bold;
			text-transform: uppercase;
			transition: transform 0.3s ease;
			cursor: pointer;

			&:hover {
				color: #0098DA;
				text-decoration: none;
			}

			&.active {
				color: #0098DA;
				font-weight: bold;
				border-bottom: 2px solid #0098DA;
			}
		}
	}

	.notification-section {
		display: flex;
		justify-content: center; /* Mengatur posisi secara horizontal */
		align-items: center;
		min-height: 300px;
	}

	.unread {
		background-color: '$highlight_color';
	}

	.card-notification {
		border-bottom: .8px solid rgba(128, 128, 128, 0.286);
	}

	.unread-dot {
		position: absolute;
		right: -5px;
		top: 15px;
		width: 8px;
		height: 8px;
		background-color: red;
		border-radius: 50%;
	}
</style>
